// extracted by mini-css-extract-plugin
export var heroImage = "_fa-1";
export var modal = "_fa-0";